import script from "./BookingReserve.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingReserve.vue?vue&type=script&setup=true&lang=js"

import "./BookingReserve.vue?vue&type=style&index=0&id=f81d2184&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f81d2184"]])

export default __exports__